const UploadBox = {
    backgroundColor: "white",
    width: "100%",
    height: "100%",
    padding: "36px",
    boxSizing: "border-box"
  
  }
  
  export default UploadBox;